<template>
    <div>
    <!-- HEADER TITULO -->
        <div class="titulo-contenido">
            <h1>
                <span class="negrita">LEGISLACIÓN</span>
            </h1>
        </div>
    <!-- OPCIONES INTERNAS(TABS) -->
        <div class="menuOpciones_tabs d-flex justify-content-center" style="background: white;">
            <ul class="d-flex horizontal-scroll-contenedor">
                <li class="opc">
                   <router-link :to="{name: 'municipal'}"  id="opcMunicipal"> Municipal </router-link>
                </li>
                <li class="opc">
                    <router-link :to="{name: 'estatal'}" id="opcEstatal">Estatal</router-link>
                </li>
                <li class="opc">
                    <router-link :to="{name: 'federal'}" id="opcFederal">Federal</router-link>
                </li>
                <li class="opc">
                    <router-link :to="{name:'legislacion-periodico-oficial'}" id="opcPeriodico">Periódico oficial</router-link>
                </li>
            </ul>
        </div>
        <div class="container"> <!-- contenedor_padre-->
            <router-view></router-view>
        </div>

    </div>
</template>

<script>


export default {
    data: function(){
        return{

        }
    },
    mounted(){
        window.scrollTo(0, 0);
    },
    components:{

    },
    methods:{

    },
    watch:{

    }
}
</script>
